import store from '~/store'

/**
 * Redirect a user to its own profile if given user doesn't exist.
 */
export default async (to, from, next) => {

  // If user is accessing its profile, proceed.

  const user = store.getters['auth/user'];

  if (to.params.id == user.id) {
    return next();
  }

  // If given user doesn't exist, redirect to user's profile.

  const users = store.getters['users/users'];

  if (users.any(u => u.id == to.params.id)) {
    next()
  } else {
    next({ name: 'settings', params: { id: user.id } })
  }

}



// WEBPACK FOOTER //
// ./resources/js/middleware/user.js